import CustomDatePicker from "../DatePicker/CustomDatePicker";
import { TextFieldForViewOnly } from "../TextField/TextField";

export const YearPicker = ({
  year,
  onChange,
  reference,
  style = { width: 70 },
  isMaxDate = true,
  filterYears = [],
  customMaxDate = null,
  allowManualInput = false,
  canEdit = true,
  ...props
}) => {
  // Compute selected date from year
  const selected = year ? new Date(year, 0) : null;

  // Filter function for allowed years
  const filterDate = (date) => {
    if (filterYears && filterYears.length > 0) {
      return !filterYears.includes(date.getFullYear());
    }
    return true;
  };

  // Handle change to return only year (and reference)
  const handleChange = (date) => {
    if (date && date.getFullYear) {
      onChange(date.getFullYear(), reference);
    } else {
      onChange(null, reference);
    }
  };

  if (!canEdit) {
    return <TextFieldForViewOnly value={year} />;
  }

  return (
    <CustomDatePicker
      selected={selected}
      onChange={handleChange}
      dateFormat='yyyy'
      showYearPicker
      maxDate={
        isMaxDate
          ? customMaxDate
            ? customMaxDate
            : new Date(new Date().setFullYear(new Date().getFullYear()))
          : null
      }
      filterDate={filterDate}
      allowManualInput={allowManualInput}
      fullWidth={false}
      size='small'
      style={{ width: 70, ...style }}
      labelSx={{ color: "white" }}
      showAdornments={false}
      {...props}
    />
  );
};
